module.exports = __webpack_public_path__ + "static/media/hamsyl.f66177f8.png";